import { SelectCellFormatter } from './formatters';
import { useRowSelection } from './hooks';
import type { Column, FormatterProps, GroupFormatterProps } from './types';
import { stopPropagation } from './utils';

export const SELECT_COLUMN_KEY = 'select-row';

function SelectFormatter(props: FormatterProps) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={-1}
      isCellSelected={props.isCellSelected}
      value={isRowSelected}
      onClick={stopPropagation}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ rowIdx: props.rowIdx, checked, isShiftClick });
      }}
    />
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SelectGroupFormatter(props: GroupFormatterProps<any, any>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select Group"
      tabIndex={-1}
      isCellSelected={props.isCellSelected}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ checked, isShiftClick: false, rowIdx: props.rowIdx });
      }}
      // Stop propagation to prevent row selection
      onClick={stopPropagation}
    />
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SelectColumn: Column<any, any> = {
  key: SELECT_COLUMN_KEY,
  name: '',
  width: 35,
  maxWidth: 35,
  resizable: false,
  sortable: false,
  frozen: true,
  headerRenderer(props) {
    return (
      <SelectCellFormatter
        aria-label="Select All"
        isCellSelected={false}
        value={props.allRowsSelected}
        onChange={props.onAllRowsSelectionChange}
      />
    );
  },
  formatter: SelectFormatter,
  groupFormatter: SelectGroupFormatter
};
